import { render, staticRenderFns } from "./media-types-table.vue?vue&type=template&id=5d09485d&scoped=true"
import script from "./media-types-table.vue?vue&type=script&lang=js"
export * from "./media-types-table.vue?vue&type=script&lang=js"
import style0 from "./media-types-table.vue?vue&type=style&index=0&id=5d09485d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d09485d",
  null
  
)

export default component.exports